import { render, staticRenderFns } from "./QuickSearchPolicyItem.vue?vue&type=template&id=8c95d704&"
import script from "./QuickSearchPolicyItem.vue?vue&type=script&lang=js&"
export * from "./QuickSearchPolicyItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports